<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/X2ELsu/tc-custom/9781683505266.jpg?1704761281356" alt="This image is the cover for the book Power of Things Unseen"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Power of Things Unseen
      </h1>
      <p class="bookDescription body article font2">
        <i>The Power of Things Unseen</i> tells a riveting true story about a woman whose <i>inner voice</i> leads her on an enthralling and nerve-racking journey, pursuing what is written in her heart. Chock-full of tales combining raw emotion, unbridled humor, and miraculous intervention, she regales the reader with her exploits as an aid worker in post-communist Romania and as a business entrepreneur in the USA. <p>It takes courage to follow your gut, buck the “right way” of doing things, and step out into the unknown, but it is only then that you can really live to your full potential. This compelling narrative of a young mother who takes an intuitive path with almost no resources will inspire you to follow your own <i>inner voice</i> and unleash <i>The Power of Things Unseen</i>.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Leanne R. Wood
      </h2>
      
      <p class="authorDescription body article">Leanne R Wood is a spirited trailblazer, business entrepreneur, author, and keynote speaker. She has lived in New Zealand, Switzerland, Ireland, Canada, England, Scotland, Romania and the USA. Her raw honesty, deep passion, ability to laugh at things, and heartfelt communication skills have been honed by following her intuition and listening to her inner voice. Leanne has two daughters and a granddaughter. She resides with her lifelong fellow adventurer and husband, Murray, in Santa Barbara, CA.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Morgan James Publishing
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?0dc31383